"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTracker = void 0;
var react_1 = __importStar(require("react"));
var client_provider_1 = require("./client-provider");
/**
 * Use the Segment provider to add the initial identify and page calls.
 */
function UserTracker(props) {
    var children = props.children, user = props.user;
    var analytics = (0, client_provider_1.useSegmentClientContext)().client;
    // Whenever the user changes call analytics.identify so that all
    // track and page calls will be associated with that user.
    (0, react_1.useEffect)(function () {
        if (user) {
            // We should only call identify if the user is logged in. For anonymous users
            // this should never be called. Segment will create an anonymous ID for the user
            // and store that in local storage.
            // Calling identify in analytics.js will automatically associate all future track
            // calls with this user. This is not have the node client works.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analytics.identify(user);
        }
    }, [analytics, user]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
}
exports.UserTracker = UserTracker;
